module KendoExtension {
    export class Editor {
        static setup($editor: JQuery) {
            $editor.find(".k-window-content").css("overflow", "visible");
            $editor.find("[data-val-required]").closest(".editor-field").each((index, field) => {
                var label = $(field).prev("div").children("label");
                if (label.length > 0) {
                    label.text(label.text() + " *");
                }
            });
            var input;
            if ($editor.data('kendoWindow') != undefined) {
                $editor.data('kendoWindow').bind('activate', () => {
                    var field = $editor.find(".editor-field").not(":has(.k-state-disabled)").first();
                    input = field.find(".k-dropdown, input, :not(k-state-disabled)");
                    if (input.length > 0) {
                        input.focus();
                        setTimeout(() => { input.select(); }, 50);
                    } else {
                        input = field.find(":input, :not(k-state-disabled)").first();
                        input.select();
                        input.focus();
                    }
                });
            } else {
                input = $editor.find(".k-input, input").first();
                if (input.length > 0) {
                    input.select();
                    input.focus();
                }
            }
        }
        
        static checkReadonly(e: kendo.ui.GridEditEvent) {
            var editButton = e.sender.tbody.find("tr[data-uid='" + e.model.uid + "']").find(".k-grid-edit, .k-grid-update, .k-grid-update-command, .k-grid-edit-command");
            var editIcon = $(editButton).find(".k-edit, .k-i-edit, .k-i-update,.k-svg-i-pencil, .k-i-pencil");
            var searchIcon = e.sender.tbody.find("tr[role='row']").find("span.k-i-search");
            var isPopup = e.container.data('kendoWindow') != undefined;
     
            if ((editIcon.length === 0 && isPopup) || (!isPopup && searchIcon.length > 0)) { //Read only.
                e.container.find(".k-textbox, .k-input").attr("disabled", "disabled");
                e.container.find(".k-select").hide();
                e.container.find("[data-role='dropdownlist']").each(function () {
                    (<kendo.ui.DropDownList>$(this).data("kendoDropDownList")).readonly(true);
                });
                e.container.find(".k-grid-update").hide();
            }
            if (!isPopup) {
                if (editButton != undefined) {
                    var innerContent = editButton.html();
                    innerContent = innerContent.replace("Update", "");
                    editButton.html(innerContent);
                    editButton.attr("title", "Save");
                }
                var cancelButton = e.sender.tbody.find("tr[data-uid='" + e.model.uid + "']").find(".k-grid-cancel,.k-grid-cancel-command");
                if (cancelButton != undefined) {
                    innerContent = cancelButton.html();
                    innerContent = innerContent.replace("Cancel", "");
                    cancelButton.html(innerContent);
                    cancelButton.attr("title", "Cancel");
                }

            }
        }
    }
}